import FormattedMessage from 'I18n/components/FormattedMessage';
import MaybeCancellationAndRefundPolicies from './MaybeCancellationAndRefundPolicies';
import TermsOfService from './TermsOfService';
import { View } from 'foundations-components/components/View';
import { useMerchantTermsOfServiceMessage } from '../../hooks/useMerchantTermsOfServiceMessage';
import { HR } from 'foundations-components/transitional/components/HR';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TermsOfServiceMessages = ({
  policySettings,
  onlyPMOF,
  isZeroCheckout
}) => {
  const translationMessageKey = useMerchantTermsOfServiceMessage();
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "terms-of-service-messages",
    children: [onlyPMOF ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.paymentMethodOnFile.message"
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [!policySettings.acknowledgementRequired && /*#__PURE__*/_jsx(TermsOfService, {
        translationMessageKey: translationMessageKey,
        isZeroCheckout: isZeroCheckout
      }), !policySettings.acknowledgementRequired && /*#__PURE__*/_jsx(View, {
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsx(MaybeCancellationAndRefundPolicies, {
          policySettings: policySettings
        })
      })]
    }), /*#__PURE__*/_jsx(HR, {})]
  });
};
export default TermsOfServiceMessages;